<!-- Vertical Menu -->
@if (layout === "vertical") {
  @for (item of menu; track item) {
    <!-- section -->
    @if (item.type == "section" && checkPermission(item)) {
      <li
        core-menu-vertical-section
        [item]="item"
        class="navigation-header"
        [ngClass]="{
          'hide-mobile': !item.aufHandyAnzeigen,
        }"></li>
    }
    <!-- sub-menu item/collapsible of sections  -->
    @if (item.type == "section" && checkPermission(item)) {
      @for (item of item.children; track item) {
        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        @if (item.type == "item" && checkPermission(item)) {
          <li
            core-menu-vertical-item
            [item]="item"
            [ngClass]="{ disabled: item.disabled === true, 'hide-mobile': !item.aufHandyAnzeigen }"
            [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
            <span
              [routerLink]="item.openInNewTab ? [] : [item.url]"
              class="d-none"></span>
          </li>
        }
        <!-- collapsible -->
        @if (item.type == "collapsible" && checkPermission(item)) {
          <li
            core-menu-vertical-collapsible
            [item]="item"
            class="nav-item has-sub"
            [ngClass]="{
              'hide-mobile': !item.aufHandyAnzeigen,
            }"></li>
        }
      }
    }
    <!-- item -->
    @if (item.type == "item" && checkPermission(item)) {
      <li
        core-menu-vertical-item
        [item]="item"
        [ngClass]="{ disabled: item.disabled === true, 'hide-mobile': !item.aufHandyAnzeigen }"
        [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span
          [routerLink]="item.openInNewTab ? [] : [item.url]"
          class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (item.type == "collapsible" && checkPermission(item)) {
      <li
        core-menu-vertical-collapsible
        [item]="item"
        class="nav-item has-sub"
        [ngClass]="{
          'hide-mobile': !item.aufHandyAnzeigen,
        }"></li>
    }
  }
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (layout === "horizontal") {
  @for (item of menu; track item) {
    <!-- section -->
    @if (item.type == "section" && checkPermission(item)) {
      <li
        core-menu-horizontal-collapsible
        [item]="item"
        class="dropdown nav-item"
        [ngClass]="{
          'hide-mobile': !item.aufHandyAnzeigen,
        }"></li>
    }
    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    @if (item.type == "item" && checkPermission(item)) {
      <li
        core-menu-horizontal-item
        [item]="item"
        [ngClass]="{ disabled: item.disabled === true, 'hide-mobile': !item.aufHandyAnzeigen }"
        [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
        <span
          [routerLink]="item.openInNewTab ? [] : [item.url]"
          class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (item.type == "collapsible" && checkPermission(item)) {
      <li
        core-menu-horizontal-collapsible
        [item]="item"
        class="dropdown dropdown-submenu"
        [ngClass]="{
          'hide-mobile': !item.aufHandyAnzeigen,
        }"></li>
    }
  }
}
<!--/ Horizontal Menu -->
